import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-formations',
  templateUrl: './details-formations.component.html',
  styleUrls: ['../initier-formations.component.scss']
})
export class DetailsFormationsComponent implements OnInit {
  @Input() type: string;
  @Input() details: any;
  constructor() { }

  ngOnInit() {
  }

  getClass() {
    return this.type === 'bulk' ? 'col-md-3 mt-3' : 'col-md-3';
  }

  getSpecificClass() {
    return this.type === 'bulk' ? 'col-md-3 mt-3' : 'col-md-4';
  }

}
